// 团队管理
const TeamList = () => import('@/pages/backstage/team-list.vue');
// 数据字典
const DictionaryList = () => import('@/pages/backstage/dictionary-list.vue');
// 团队字典配置
const TeamConfig = () => import('@/pages/backstage/team-config-list.vue');
// 用户管理
const UserList = () => import('@/pages/backstage/user-list.vue');
// 权限管理
const AuthList = () => import('@/pages/backstage/auth/index');
// 系统日志
const Log = () => import('@/pages/backstage/log/index');
// 角色管理
const RoleList = () => import('@/pages/backstage/role-list.vue');
// 角色用户
const RoleUserList = () => import('@/pages/backstage/role-user-list.vue');
// 菜单管理
const menuMng = () => import('@/pages/backstage/menuMng/index');
// 产品管理
const productManage = () => import('@/pages/backstage/productManage.vue');
const arr = [
  // 团队管理
  {
    path: '/teammanage',
    name: 'teamList',
    component: TeamList,
    meta: {
      auth: false,
    },
  },
  // 数据字典
  {
    path: '/backstage/dictionary',
    name: 'dictionaryList',
    component: DictionaryList,
    meta: {
      auth: false,
    },
  },
  // 团队字典配置
  {
    path: '/backstage/user',
    name: 'userList',
    component: UserList,
    meta: {
      auth: false,
    },
  },
  // 用户管理
  {
    path: '/backstage/teamConfig',
    name: 'teamConfig',
    component: TeamConfig,
    meta: {
      auth: false,
    },
  },
  // 权限管理
  {
    path: '/backstage/auth',
    name: 'authList',
    component: AuthList,
    meta: {
      auth: false,
    },
  },
  {
    path: '/backstage/log',
    name: 'LogList',
    component: Log,
    meta: {
      auth: false,
    },
  },
  // 角色管理
  {
    path: '/backstage/roleMng',
    name: 'roleList',
    component: RoleList,
    meta: {
      auth: false,
    },
  },
  {
    path: '/backstage/roleUserList',
    name: 'roleUserList',
    component: RoleUserList,
    meta: {
      auth: false,
    },
  },
  {
    path: '/backstage/menuMng',
    name: 'menuMng',
    component: menuMng,
    meta: {
      auth: false,
    },
  },
  {
    path: '/backstage/productManage',
    name: 'productManage',
    component: productManage,
    meta: {
      auth: false,
    },
  },
];

export default arr;
